import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { Category, Product, Talle } from 'src/app/types/types';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  products: Product[];
  productsToShow: Product[];
  categories : Category[] = [];
  talles : Talle[] = [];
  form : FormGroup;
  filtered : boolean = false;
  loading : boolean = true;

  constructor(private productService : ProductService,
     private route: ActivatedRoute,
     private router : Router
     ) {

   }
  
  ngOnInit(): void {
    this.productService.getAllVisibleProducts().subscribe((res: Product[]) => {
      this.products = res;
      this.productsToShow = res;
      this.loading = false;
      this.categories = this.productService.getCategories();
      this.talles = this.productService.getTalles();
      this.form = new FormGroup({
        name:new FormControl("",[]),
        category : new FormControl("",[])
      });
      this.talles.forEach( t => {
        this.form.addControl(t,new FormControl(false,[]))
      });
      this.filterByQueryParams();
    });
    debugger;
    
  }

  filterByQueryParams() {
    this.route.queryParamMap
      .subscribe((paramsMap : any) => {
        console.log(paramsMap.params)
        this.form.get('name').setValue(paramsMap.params.name || '');
        this.form.get('category').setValue(paramsMap.params.category?.toUpperCase() || '');
        paramsMap.params.talles?.split(",").map(talle => this.form.get(talle).setValue(true));
      }
    );
    console.log(this.form)
    this.applyFilter();
  }

  matchName(nameForm:string, name : string){
    return nameForm ? name.toLocaleLowerCase().includes(nameForm.toLocaleLowerCase()) : true 
  } 

  matchCategory(categoryForm : string, category : string) {
    return !this.form.get("category").pristine ? category ==  categoryForm : true
  }

  matchTalle(anyTalleSelected : boolean, talles : Talle[], talleForm : (Talle) => boolean) {
    return anyTalleSelected ? talles.some(t => talleForm(t)) : true
  }

  applyFilter() {
    const talleForm = (t:Talle) => this.form.get(t).value

    const nameForm = this.form.get('name').value;
    const categoryForm = this.form.get('category').value;
    const anyTalleSelected = this.talles.some(t => talleForm(t))

    if( nameForm || categoryForm || anyTalleSelected){
      console.log("ALL");
      this.filtered = true;
      debugger;
      this.productsToShow = this.products
                .filter((p : Product) => this.matchName(nameForm, p.name))
                .filter((p : Product) => this.matchCategory(categoryForm,p.category))
                .filter((p : Product) => this.matchTalle(anyTalleSelected, p.talles, talleForm))
    }
    else {
      this.cleanFilter()
    }
  }

  cleanFilter() {
    this.productsToShow = this.products
    this.filtered = false
    this.form.reset()
    this.resetQueryParams();
  }

  resetQueryParams() {
    this.router.navigate([],{
      queryParams: {
        'name': null,
        'category': null,
        'talles' : null
      },
      queryParamsHandling: 'merge'
    })
  }

  get invalidCategory() {
    return false;
  }

}
